import React from 'react';
import { BarChart, HelpCircle, Calendar } from 'lucide-react';

interface GameHeaderControlsProps {
  onShowStats: () => void;
  onShowCalendar: () => void;
  onShowInstructions?: () => void;
  gameMode?: string; // Current game mode
  hasDailyChallenge?: boolean; // Whether a daily challenge is available
}

const GameHeaderControls: React.FC<GameHeaderControlsProps> = ({
  onShowStats,
  onShowCalendar,
  onShowInstructions,
  gameMode = 'daily',
  hasDailyChallenge = true, // Default to true since it's required for the button to show
}) => {
  const isDailyMode = gameMode === 'daily';

  return (
    <div className="flex items-center gap-2">
      {/* Stats button - only show in daily challenge mode */}
      {isDailyMode && (
        <button
          onClick={onShowStats}
          className="p-2 bg-white/10 rounded text-white hover:bg-[#4A3D5F] transition-colors"
          title="View Stats"
        >
          <BarChart size={24} />
        </button>
      )}

      <button
        onClick={onShowCalendar}
        className="p-2 bg-white/10 rounded text-white hover:bg-[#4A3D5F] transition-colors"
        title="View Calendar"
      >
        <Calendar size={24} />
      </button>

      {/* Optional Instructions button - always show if provided */}
      {onShowInstructions && (
        <button
          onClick={onShowInstructions}
          className="p-2 bg-white/10 rounded text-white hover:bg-[#4A3D5F] transition-colors"
          title="Instructions"
        >
          <HelpCircle size={24} />
        </button>
      )}
    </div>
  );
};

export default GameHeaderControls;
